import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { ref, onMounted, watch, computed } from 'vue';
import { useRoute, useRouter } from '@nuxtjs/composition-api';
export default defineComponent({
  props: {
    selected: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    sortKeys: {
      type: Array,
      required: true
    },
    hasBatchActions: {
      type: Boolean,
      default: false
    },
    esgToolbar: {
      type: Boolean,
      default: false
    },
    toolbarType: {
      type: String,
      default: 'esg'
    },
    defaultPeriods: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var route = useRoute();
    var router = useRouter();
    var isGroupEnabled = ref(false);
    var isDescending = ref(false);
    var sortBy = ref('');
    var selectedGroup = ref('');
    var fallbackPeriodMin = 2020;
    var fallbackPeriodMax = 2030;
    var normalizedDefaultPeriods = computed(function () {
      return (props.defaultPeriods || []).map(function (v) {
        return Number(v);
      }).filter(function (v) {
        return Number.isFinite(v);
      }).sort(function (a, b) {
        return a - b;
      });
    });
    var periodMinTick = ref(fallbackPeriodMin);
    var periodMaxTick = ref(fallbackPeriodMax);
    var periodRange = ref([periodMinTick.value, periodMaxTick.value]);
    var periodYearLabels = computed(function () {
      var labels = [];
      for (var y = periodMinTick.value; y <= periodMaxTick.value; y += 1) {
        labels.push(String(y));
      }
      return labels;
    });
    var syncPeriodRangeFromQuery = function syncPeriodRangeFromQuery() {
      var defaults = normalizedDefaultPeriods.value;
      // Keep full range selectable; defaults only drive initial selection.
      periodMinTick.value = fallbackPeriodMin;
      periodMaxTick.value = fallbackPeriodMax;
      var qsStart = route.query.periodStart;
      var qsEnd = route.query.periodEnd;
      if (!qsStart || !qsEnd) {
        if (defaults.length > 0) {
          var fromYear = Math.max(periodMinTick.value, Math.min(defaults[0], periodMaxTick.value));
          var toYear = Math.max(periodMinTick.value, Math.min(defaults[defaults.length - 1], periodMaxTick.value));
          periodRange.value = [fromYear, toYear];
          router.replace({
            query: _objectSpread(_objectSpread({}, route.query), {}, {
              periodStart: "".concat(fromYear, "-01-01"),
              periodEnd: "".concat(toYear, "-12-31")
            })
          });
          return;
        }
        // Fallback full range when no defaults/query params are set
        periodRange.value = [periodMinTick.value, periodMaxTick.value];
        return;
      }
      var startYear = parseInt(qsStart.slice(0, 4), 10);
      var endYear = parseInt(qsEnd.slice(0, 4), 10);
      var clampedStart = Math.max(periodMinTick.value, Math.min(startYear, periodMaxTick.value));
      var clampedEnd = Math.max(periodMinTick.value, Math.min(endYear, periodMaxTick.value));
      periodRange.value = [Math.min(clampedStart, clampedEnd), Math.max(clampedStart, clampedEnd)];
    };
    onMounted(function () {
      isDescending.value = route.query.sortDesc === 'true';
      sortBy.value = route.query.sortBy || 'esg.total';
      selectedGroup.value = route.query.group || '';
      syncPeriodRangeFromQuery();
    });

    // Keep switch in sync if query changes from elsewhere
    watch(function () {
      return [route.query.group, route.query.sortDesc, route.query.sortBy, route.query.periodStart, route.query.periodEnd, normalizedDefaultPeriods.value.join(',')];
    }, function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
        newGroup = _ref2[0],
        newSortDesc = _ref2[1],
        newSortBy = _ref2[2];
      isDescending.value = newSortDesc === 'true';
      sortBy.value = newSortBy;
      selectedGroup.value = newGroup;
      syncPeriodRangeFromQuery();
    });
    var updateSelectedGroup = function updateSelectedGroup(value) {
      if (value === 'venture.name') {
        router.push({
          query: _objectSpread(_objectSpread({}, route.query), {}, {
            group: value,
            sortDesc: 'false'
          })
        });
      } else {
        router.push({
          query: _objectSpread(_objectSpread({}, route.query), {}, {
            group: value,
            sortDesc: 'true'
          })
        });
      }
    };
    var updatePeriodRange = function updatePeriodRange(value) {
      if (!value || value.length !== 2) return;
      var _value = _slicedToArray(value, 2),
        startYearRaw = _value[0],
        endYearRaw = _value[1];
      var startYear = Math.floor(startYearRaw);
      var endYear = Math.floor(endYearRaw);
      var fromYear = Math.min(startYear, endYear);
      var toYear = Math.max(startYear, endYear);
      var toIsoStart = "".concat(fromYear, "-01-01");
      var toIsoEnd = "".concat(toYear, "-12-31");
      router.push({
        query: _objectSpread(_objectSpread({}, route.query), {}, {
          periodStart: toIsoStart,
          periodEnd: toIsoEnd
        })
      });
    };
    return {
      route: route,
      router: router,
      isGroupEnabled: isGroupEnabled,
      isDescending: isDescending,
      sortBy: sortBy,
      selectedGroup: selectedGroup,
      updateSelectedGroup: updateSelectedGroup,
      periodMinTick: periodMinTick,
      periodMaxTick: periodMaxTick,
      periodRange: periodRange,
      periodYearLabels: periodYearLabels,
      updatePeriodRange: updatePeriodRange
    };
  }
});